import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { EVocabularyBookStudyType, EWorkbookItemType } from '@datatype/iyagigo/type';

interface IState {
  // cloze 미러: study type + item type으로 진입 경로 + 모드 표현
  vocabularyBookStudyType: EVocabularyBookStudyType;
  vocabularyBookItemType: EWorkbookItemType;
  // 노트(저장/틀린) SINGLE 모드에서 단건 워크북 매칭용 key
  currentNoteWorkbookKey: string | null;
}

const initialState: IState = {
  vocabularyBookStudyType: EVocabularyBookStudyType.BOOK_STUDY,
  vocabularyBookItemType: EWorkbookItemType.BUNDLE,
  currentNoteWorkbookKey: null,
};

const vocabularyBookSlice = createSlice({
  name: 'vocabularyBook',
  initialState,
  reducers: {
    initialize: (state) => {
      for (const key in state) {
        state[key] = initialState[key];
      }
    },
    // ############### vocabulary book 설정 (cloze configure 패턴 미러) ###############
    configureVocabularyBookStudy: (state) => {
      state.vocabularyBookStudyType = EVocabularyBookStudyType.BOOK_STUDY;
      state.vocabularyBookItemType = EWorkbookItemType.BUNDLE;
      state.currentNoteWorkbookKey = null;
    },
    configureVocabularyBookBookmarkNote: (state, action: PayloadAction<{ workbookKey?: string }>) => {
      state.vocabularyBookStudyType = EVocabularyBookStudyType.BOOKMARK_NOTE;
      state.vocabularyBookItemType = action.payload.workbookKey ? EWorkbookItemType.SINGLE : EWorkbookItemType.BUNDLE;
      state.currentNoteWorkbookKey = action.payload.workbookKey ?? null;
    },
    configureVocabularyBookIncorrectNote: (state, action: PayloadAction<{ workbookKey?: string }>) => {
      state.vocabularyBookStudyType = EVocabularyBookStudyType.INCORRECT_NOTE;
      state.vocabularyBookItemType = action.payload.workbookKey ? EWorkbookItemType.SINGLE : EWorkbookItemType.BUNDLE;
      state.currentNoteWorkbookKey = action.payload.workbookKey ?? null;
    },
    configureVocabularyBookReview: (state) => {
      state.vocabularyBookStudyType = EVocabularyBookStudyType.REVIEW;
      state.vocabularyBookItemType = EWorkbookItemType.BUNDLE;
      state.currentNoteWorkbookKey = null;
    },
  },
});

export const actions = vocabularyBookSlice.actions;
export default vocabularyBookSlice.reducer;
